import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/dashboard.svg'
import _imports_1 from '@/app/ui/assets/svg/no-notif.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-31305e97")

_pushScopeId("data-v-31305e97")
const _hoisted_1 = { class: "flex overflow-hidden flex-row items-center text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_3 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_5 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_6 = { class: "text-red-lp-2000" }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row items-center"
}
const _hoisted_8 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_9 = {
  key: 3,
  class: "flex flex-row items-center"
}
const _hoisted_10 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_11 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_12 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_15 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_16 = { class: "text-red-lp-2000 font-bold" }
const _hoisted_17 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_18 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_19 = { class: "flex items-center gap-5" }
const _hoisted_20 = {
  key: 0,
  class: 
              `rounded-full border border-white absolute top-0 left-2 bg-red-lp-2000`
            ,
  style: {"width":"10px","height":"10px"}
}
const _hoisted_21 = { class: "flex items-center justify-between text-xs" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = { class: "font-semibold" }
const _hoisted_24 = {
  key: 0,
  class: "inline-block bg-gray-300 animate-pulse rounded-full px-3 text-transparent"
}
const _hoisted_25 = {
  key: 1,
  class: "inline-block bg-green-600 text-white text-xs leading-none px-3 py-1 rounded-full shadow-sm"
}
const _hoisted_26 = {
  key: 0,
  class: "w-full bg-white justify-center items-center flex flex-col mx-auto text-12px xxl:text-14px overflow-hidden rounded-b-md"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-32 mx-auto",
  alt: ""
}, null, -1)
const _hoisted_28 = { class: "text-12px xxl:text-14px text-gray-lp-800 font-normal py-2 px-10 text-center" }
const _hoisted_29 = {
  key: 1,
  class: "flex flex-col items-start hover:bg-gray-50 cursor-pointer"
}
const _hoisted_30 = { class: "px-6 py-4 text-12px text-gray-lp-500" }
const _hoisted_31 = { class: "w-6 mr-2" }
const _hoisted_32 = { class: "flex flex-col text-12px w-full" }
const _hoisted_33 = { class: "flex flex-row justify-between" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "font-semibold mx-1" }
const _hoisted_36 = { class: "text-gray-lp-500 font-semibold" }
const _hoisted_37 = { class: "flex gap-4 mt-2" }
const _hoisted_38 = { class: "w-3.5 h-3.5 rounded-full bg-white flex items-center justify-center" }
const _hoisted_39 = { class: "text-gray-lp-200 font-semibold" }
const _hoisted_40 = { class: "text-gray-lp-200 font-semibold" }
const _hoisted_41 = {
  key: 1,
  class: "text-gray-lp-300 mr-6"
}
const _hoisted_42 = { class: "font-semibold" }
const _hoisted_43 = { class: "text-gray-lp-500 whitespace-no-wrap" }
const _hoisted_44 = {
  key: 1,
  class: "flex flex-row rounded-3xl bg-gray-lp-200 px-2 items-center justify-center gap-2 py-1"
}
const _hoisted_45 = { class: "text-xs text-gray-lp-300 font-semibold" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = { class: "font-semibold text-xs" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CustomOverlay = _resolveComponent("CustomOverlay")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "breadcrumb",
      class: ["flex flex-row justify-between bg-white w-full border-b pb-2", _ctx.$attrs.class]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
          class: "w-5 cursor-pointer",
          alt: "dashboard"
        }),
        _createVNode("span", {
          class: "text-gray-lp-500 font-semibold text-xs cursor-pointer hover:text-red-lp-2000 pl-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
        }, _toDisplayString(_ctx.$t("breadcrumb.home")), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrentRoute?.matched, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: ["flex flex-row font-medium", { 'font-semibold text-sm': _ctx.isSemiboldBreadcrumb }]
          }, [
            (!item.meta.children && index === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("span", _hoisted_3, [
                    _createVNode(_component_Icons, {
                      name: "chevron-right-thin",
                      style: {"width":"6px"}
                    })
                  ]),
                  _createVNode("div", {
                    class: 
              `${_ctx.nameUpdateFeature(item.meta.name) ===
                _ctx.getCurrentRoute.meta.name &&
                !_ctx.isDashboardDetail &&
                _ctx.decideBreadcrumbColor} hover:${_ctx.decideBreadcrumbColor} ${
                _ctx.isDashboardDetail ? 'cursor-pointer' : ''
              }`
            ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDashboardDetail ? _ctx.goHome() : {}))
                  }, _toDisplayString(_ctx.translatedFeatureName(
                (item.meta.customName || item.meta.name) ?? ""
              )), 3)
                ]))
              : _createCommentVNode("", true),
            (!!_ctx.customBreadcrumbTitle && index === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode(_component_Icons, {
                      name: "chevron-right-thin",
                      style: {"width":"6px"}
                    })
                  ]),
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.customBreadcrumbTitle), 1)
                ]))
              : _createCommentVNode("", true),
            (item.meta.children)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, [
                    _createVNode(_component_Icons, {
                      name: "chevron-right-thin",
                      style: {"width":"6px"}
                    })
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _withDirectives(_createVNode("div", {
                        class: 
                `${(item.meta.hadSameName
                  ? item.name === _ctx.getCurrentRoute.name
                  : _ctx.nameUpdateFeature(item.meta.name) ===
                    _ctx.getCurrentRoute.meta.name) &&
                  'text-red-lp-2000 font-bold'} hover:text-red-lp-2000`
              
                      }, _toDisplayString(_ctx.nameUpdateFeature(_ctx.$t((item.meta.customName || item.meta.name) ?? ""))), 3), [
                        [_vShow, item.meta.hadSameName ? item.name === _ctx.getCurrentRoute.name : _ctx.nameUpdateFeature(item.meta.name) === _ctx.getCurrentRoute.meta.name]
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (item.meta.parent)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _withDirectives(_createVNode("span", _hoisted_10, [
                    _createVNode(_component_Icons, {
                      name: "chevron-right-thin",
                      style: {"width":"6px"}
                    })
                  ], 512), [
                    [_vShow, item.meta.name]
                  ]),
                  (index !== _ctx.getCurrentRoute?.matched.length - 1)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "hover:text-red-lp-2000 cursor-pointer",
                        onClick: () => _ctx.goPath(item.meta['parent-path'] || item.path)
                      }, _toDisplayString(_ctx.translatedFeatureName(item.meta.parent ?? "")), 9, ["onClick"]))
                    : _createCommentVNode("", true),
                  (item.children[0]?.meta?.before)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("span", _hoisted_12, [
                          _createVNode(_component_Icons, {
                            name: "chevron-right-thin",
                            style: {"width":"6px"}
                          })
                        ]),
                        _createVNode("div", {
                          class: "cursor-pointer hover:text-red-lp-2000 flex flex-row items-center",
                          onClick: 
                () =>
                  _ctx.goDetail(
                    item.children[0]?.meta?.before,
                    _ctx.getCurrentRoute.params.id
                  )
              
                        }, [
                          (_ctx.params.params)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: 
                  `text-red-lp-2000 font-bold ${_ctx.id &&
                    index !== _ctx.getCurrentRoute?.matched.length - 1}`
                
                              }, _toDisplayString(_ctx.params.params), 3))
                            : (item.children[0].meta.pathBefore)
                              ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(item.children[0].meta.pathBefore), 1))
                              : (_openBlock(), _createBlock("span", {
                                  key: 2,
                                  class: 
                  `${_ctx.id && index !== _ctx.getCurrentRoute?.matched.length - 1}`
                
                                }, _toDisplayString(_ctx.id), 3))
                        ], 8, ["onClick"]),
                        _withDirectives(_createVNode("span", _hoisted_14, [
                          _createVNode(_component_Icons, {
                            name: "chevron-right-thin",
                            style: {"width":"6px"}
                          })
                        ], 512), [
                          [_vShow, _ctx.id && item.meta.parent && !_ctx.params.params]
                        ]),
                        _withDirectives(_createVNode("span", { class: "text-red-lp-2000 font-bold" }, _toDisplayString(!item.children[0].meta.title
                  ? _ctx.$route.params.id
                  : _ctx.$t(item.children[0].meta.name ?? "")), 513), [
                          [_vShow, !_ctx.params.params]
                        ]),
                        (item.children[0].meta.lastBreadCrumb)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("span", _hoisted_15, [
                                _createVNode(_component_Icons, {
                                  name: "chevron-right-thin",
                                  style: {"width":"6px"}
                                })
                              ]),
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(item.children[0].meta.lastBreadCrumb ?? "")), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_17, [
                        _createVNode("span", _hoisted_18, [
                          _createVNode(_component_Icons, {
                            name: "chevron-right-thin",
                            style: {"width":"6px"}
                          })
                        ]),
                        _createVNode("span", {
                          "data-content": _ctx.id,
                          class: "text-red-lp-2000 font-bold"
                        }, _toDisplayString(_ctx.id), 9, ["data-content"])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _createVNode("div", _hoisted_19, [
        (!_ctx.isClientAccount && !_ctx.isCustomerService)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: 
          `flex items-center text-12px ${
            _ctx.isPusatResolusiMenu
              ? 'text-red-lp-2000 font-bold'
              : 'text-gray-lp-300 hover:text-red-lp-2000'
          }`
        ,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goPath('/pusat-resolusi-v2')))
            }, [
              _createVNode(_component_Icons, {
                name: "customer-service-breadcrumb",
                class: "w-5 h-5 mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("breadcrumb.pusatResolusi")), 1)
            ], 2))
          : _createCommentVNode("", true),
        _createVNode(_component_CustomOverlay, {
          overlayWidth: "362px",
          arrowPosition: "right-16",
          isContentHavePadding: false
        }, {
          trigger: _withId(() => [
            (_ctx.isNotificationsExist)
              ? (_openBlock(), _createBlock("div", _hoisted_20))
              : _createCommentVNode("", true),
            _createVNode("button", {
              class: 
              `flex items-center text-12px ${
                _ctx.getCurrentRoute.meta.name === 'Notifikasi'
                  ? 'text-red-lp-2000 font-bold'
                  : 'text-gray-lp-300 hover:text-red-lp-2000'
              }`
            ,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getUnreadList && _ctx.getUnreadList(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "bell",
                class: "w-5 h-5 mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("breadcrumb.notification")), 1)
            ], 2)
          ]),
          header: _withId(() => [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("breadcrumb.notification")), 1),
                (!_ctx.unreadData.unread)
                  ? (_openBlock(), _createBlock("span", _hoisted_24, " 00 "))
                  : (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.countUnread(_ctx.unreadData.unread)), 1))
              ]),
              _createVNode("span", {
                class: "font-semibold text-red-lp-2000 cursor-pointer",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goAllNotification && _ctx.goAllNotification(...args)))
              }, _toDisplayString(_ctx.$t("breadcrumb.seeAllMessages")), 1)
            ])
          ]),
          default: _withId(() => [
            _createVNode("div", {
              class: 
            `${_ctx.isNotificationsExist ? 'max-h-80' : 'max-h-40'} overflow-y-auto`
          
            }, [
              (!_ctx.isNotificationsExist)
                ? (_openBlock(), _createBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("breadcrumb.noMessagesToShow")), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_29, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allData, (notif, i) => {
                      return (_openBlock(), _createBlock("div", { key: i }, [
                        _createVNode("div", _hoisted_30, _toDisplayString(i), 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(notif, (item, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index.toString()
                          }, [
                            _createVNode("a", {
                              class: 
                    `${!item.read && 'bg-gray-lp-700'} ${index ===
                      notif.length - 1 &&
                      'border-b border-gray-lp-400'} cursor-pointer px-6 py-2 xxl:py-3 flex flex-row items-start`
                  ,
                              onClick: ($event: any) => (
                    _ctx.goDetailNotification(item.id, item.meta.isDeviceMaster)
                  )
                            }, [
                              _createVNode("div", _hoisted_31, [
                                _createVNode("div", {
                                  class: 
                        `${
                          _ctx.initialNameNotification(item.createdBy).color
                        } w-6 h-6 font-semibold text-10px items-center tracking-wider flex flex-col justify-center text-white rounded-full`
                      
                                }, _toDisplayString(_ctx.initialNameNotification(item.createdBy).initial), 3)
                              ]),
                              _createVNode("div", _hoisted_32, [
                                _createVNode("div", _hoisted_33, [
                                  (item.meta.isDeviceMaster)
                                    ? (_openBlock(), _createBlock("div", _hoisted_34, [
                                        _createVNode("p", null, [
                                          _createTextVNode(_toDisplayString(_ctx.$t("notification.loginRequest")) + " ", 1),
                                          _createVNode("b", null, _toDisplayString(_ctx.$t("notification.from")) + " " + _toDisplayString(item.meta.deviceAccountName), 1),
                                          _createVNode("span", _hoisted_35, _toDisplayString(item.meta.deviceName), 1),
                                          _createVNode("span", _hoisted_36, _toDisplayString(item.meta.deviceOs), 1)
                                        ]),
                                        _createVNode("div", _hoisted_37, [
                                          (_ctx.permissionButtonActionReject)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.handleConfirmation(item.meta, 'Reject')),
                                                class: "px-4 py-2 bg-red-500 rounded-md flex items-center gap-2"
                                              }, [
                                                _createVNode("div", _hoisted_38, [
                                                  _createVNode(_component_Icons, {
                                                    name: "close",
                                                    class: "w-2.5 text-red-500 font-bold"
                                                  })
                                                ]),
                                                _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("notification.reject")), 1)
                                              ], 8, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.permissionButtonActionApprove)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 1,
                                                onClick: ($event: any) => (_ctx.handleConfirmation(item.meta, 'Approve')),
                                                class: "px-4 py-2 bg-green-500 rounded-md flex items-center gap-2"
                                              }, [
                                                _createVNode(_component_Icons, {
                                                  name: "check-circle",
                                                  class: "w-4 text-white"
                                                }),
                                                _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("notification.approve")), 1)
                                              ], 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : (_openBlock(), _createBlock("div", _hoisted_41, [
                                        _createVNode("span", _hoisted_42, _toDisplayString(item.createdBy), 1),
                                        _createVNode("span", null, _toDisplayString(_ctx.getSharedNewsSnippet(
                              item.createdBy,
                              item.title,
                              90,
                              true
                            )), 1)
                                      ])),
                                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.dateToTime(item.createdAt)), 1)
                                ]),
                                (item.bannerImage && !item.meta.isDeviceMaster)
                                  ? (_openBlock(), _createBlock("img", {
                                      key: 0,
                                      src: item.bannerImage,
                                      class: "pt-4 object-cover h-20",
                                      alt: ""
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 10, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
            ], 2)
          ]),
          _: 1
        }),
        (_ctx.isCustomerService)
          ? (_openBlock(), _createBlock("div", _hoisted_44, [
              _createVNode("p", _hoisted_45, _toDisplayString(_ctx.statusAccount.status
              ? _ctx.$t("breadcrumb.active")
              : _ctx.$t("breadcrumb.inactive")), 1),
              _createVNode("div", {
                id: "toggle_hide_info_detail",
                onClick: _cache[7] || (_cache[7] = () => _ctx.onClickToggleStatus(!_ctx.statusAccount.status)),
                class: 
            `toggle-switch inline-block cursor-pointer ${
              _ctx.statusAccount.status
                ? `toggle-active ${'bg-red-lp-2000'}`
                : `${'bg-gray-lp-200'}`
            }`
          
              }, [
                _hoisted_46
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_CustomOverlay, { arrowPosition: "right-2" }, {
          trigger: _withId(() => [
            _createVNode("div", {
              class: 
              `w-8 h-8 rounded-full ${_ctx.initialName.color} text-white flex items-center justify-center font-semibold cursor-pointer`
            
            }, [
              (_ctx.isCustomerService)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: 
                `rounded-full border border-white absolute top-0 right-0 ${
                  _ctx.statusAccount.status ? 'bg-green-lp-400' : 'bg-red-lp-2000'
                }`
              ,
                    style: {"width":"10px","height":"10px"}
                  }, null, 2))
                : _createCommentVNode("", true),
              _createVNode("span", null, _toDisplayString(_ctx.initialName.initial), 1)
            ], 2)
          ]),
          header: _withId(() => [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", {
                class: 
                `w-8 h-8 rounded-full ${_ctx.initialName.color} text-white flex items-center justify-center`
              
              }, _toDisplayString(_ctx.initialName.initial), 3),
              _createVNode("span", _hoisted_48, _toDisplayString(_ctx.dataProfile.name), 1)
            ])
          ]),
          default: _withId(() => [
            _createVNode("button", {
              class: "flex items-center gap-2 w-full p-2 hover:bg-gray-50 rounded text-xs",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goPath('/account')))
            }, [
              _createVNode(_component_Icons, {
                name: "profile",
                class: "w-5 h-5 mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("breadcrumb.profile")), 1)
            ]),
            _createVNode("button", {
              class: "flex items-center gap-2 w-full p-2 hover:bg-gray-50 rounded text-xs",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onClickLogout && _ctx.onClickLogout(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "logout-breadcrumb",
                class: "w-5 h-5 mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("profile.logout")), 1)
            ])
          ]),
          _: 1
        })
      ])
    ], 2),
    (_ctx.isOpenModalLogout)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.onSubmit,
          onSubmit: _ctx.onClose,
          textSuccess: _ctx.$t('Tidak'),
          textCancel: _ctx.$t('Ya'),
          title: _ctx.$t('profile.logoutConfirmTitle'),
          message: _ctx.$t('profile.logoutConfirmMessage'),
          image: "logout-image"
        }, null, 8, ["onClose", "onSubmit", "textSuccess", "textCancel", "title", "message"]))
      : _createCommentVNode("", true)
  ], 64))
})